import React from 'react';

export default function VehicleSection({ vehicles = [], onAdd, onEdit, onDelete }) {
  return (
    <section className="space-y-8 mt-12">
      <div className="flex justify-between items-center bg-gray-100 p-4 rounded-md">
        <h2 className="text-2xl font-semibold text-gray-800">Vehicles</h2>
        <button
          onClick={onAdd}
          className="px-4 py-1 bg-blue-600 text-white rounded"
        >
          Add Vehicle
        </button>
      </div>
      {vehicles.length === 0 ? (
        <p className="text-gray-500">No vehicles added yet.</p>
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {vehicles.map(vehicle => (
            <div
              key={vehicle.id}
              className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow p-6 flex flex-col"
            >
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                {vehicle.year ? `${vehicle.year} ` : ''}
                {vehicle.make} {vehicle.model}
              </h3>
              <p className="text-sm text-gray-600"><strong>Mileage:</strong> {vehicle.mileage ?? 'N/A'}</p>
              <p className="text-sm text-gray-600">
                <strong>Monthly Payment:</strong> ${vehicle.monthly_payment ?? '0.00'}
              </p>
              <p className="text-sm text-gray-600">
                <strong>Ownership:</strong> {vehicle.ownership.replace('_', ' & ')}
              </p>
              <p className="text-sm text-gray-600">
                <strong>Exemption Code:</strong> {vehicle.exemption_code || 'N/A'}
              </p>
              <p className="text-sm text-gray-600">
                <strong>Exemption Amount:</strong> ${vehicle.exemption_amount ?? '0.00'}
              </p>
              {vehicle.is_recreational && (
                <span className="inline-block mt-1 px-2 py-1 bg-blue-100 text-blue-800 text-xs rounded">
                  Recreational
                </span>
              )}
              <div className="mt-4 flex space-x-2">
                <button
                  onClick={() => onEdit(vehicle)}
                  className="px-3 py-1 bg-yellow-500 text-white rounded"
                >
                  Edit
                </button>
                <button
                  onClick={() => onDelete(vehicle.id)}
                  className="px-3 py-1 bg-red-600 text-white rounded"
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
);
}
